module.exports = __webpack_public_path__ + "static/media/Original.8e97cc46.svg";